import React from 'react';
import { createFileRoute, Navigate, Outlet } from '@tanstack/react-router';
import { isInternalEmployee } from '@/lib/roles';
import { useAuthenticationState } from '@/hooks/use-authentication';
export const Route = createFileRoute('/console/_authenticated/_layout/internal/_layout')({
    component: InternalLayout,
});
function InternalLayout() {
    const { user } = useAuthenticationState();
    if (!isInternalEmployee(user)) {
        return <Navigate to="/console"/>;
    }
    return <Outlet />;
}
